/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";

export default {
  async getClassLevels() {
    const data = {};
    return await apiCall("class/level/list", data);
  },

  async createClassLevel(level_name) {
    const data = { level: level_name };
    return await apiCall("class/level/add", data);
  },

  async updateClassLevel(level_id, level_name) {
    const data = { level_id, level: level_name };
    return await apiCall("class/level/update", data);
  },

  async getClassRooms() {
    const data = {};
    return await apiCall("classes/list", data);
  },

  async createClass(level_id, class_name) {
    const data = { level_id, class_name };
    return await apiCall("class/add", data);
  },

  async updateClass(class_id, level_id, class_name) {
    const data = { class_id, level_id, class_name };
    return await apiCall("class/update", data);
  },

  async getClassStreams(class_id) {
    const data = { class_id };
    return await apiCall("class/stream/list", data);
  },

  async createStream(class_id, stream_name) {
    const data = { class_id, stream: stream_name };
    return await apiCall("class/stream/add", data);
  },

  async updateStream(stream_id, stream_name) {
    const data = { stream_id, stream: stream_name };
    return await apiCall("class/stream/update", data);
  },

  async getTerms() {
    const data = {};
    return await apiCall("term/list", data);
  },

  async createTerm(term_name) {
    const data = { term: term_name };
    return await apiCall("term/add", data);
  },

  async updateTerm(term_id, term_name) {
    const data = { term_id, term: term_name };
    return await apiCall("term/update", data);
  },

  async getExams() {
    const data = {};
    return await apiCall("termly_exam/list", data);
  },

  async createAssessment(exam_name, description, assessment_type) {
    const data = { exam_name, description, assessment_type };
    return await apiCall("termly_exam/add", data);
  },

  async updateAssessment(exam_id, exam_name, description, assessment_type) {
    const data = { exam_id, exam_name, description, assessment_type };
    return await apiCall("termly_exam/update", data);
  },

  async getCurrentPeriod() {
    const data = {};
    return await apiCall("period/current", data);
  },

  async getCurrentExams() {
    const data = {};
    return await apiCall("period/class/list", data);
  },

  async setCurrentPeriod(term_id, startDate, endDate) {
    const data = { term_id, start_date: startDate, end_date: endDate };
    return await apiCall("period/set", data);
  },

  async getSubjects() {
    const data = {};
    return await apiCall("subject/list", data);
  },

  async getSubjectCategories() {
    const data = {};
    return await apiCall("subject/category/list", data);
  },

  async getSubjectTypes() {
    const data = {};
    return await apiCall("subject/type/list", data);
  },

  async createSubject(subject, level_id, category_id, type_id) {
    const data = { subject, level_id, category_id, type_id };
    return await apiCall("subject/add", data);
  },

  async updateSubject(subjectId, subject, level_id, category_id, type_id) {
    const data = { subject_id: subjectId, subject, level_id, category_id, type_id };
    return await apiCall("subject/update", data);
  },

  async createSubjectPaper(subject_id, paper_code) {
    const data = { subject_id, paper_code };
    return await apiCall("subject/paper/add", data);
  },

  async deletePaper(paper_id) {
    const data = { paper_id };
    return await apiCall("subject/paper/delete", data);
  },

  async updateSubjectPaper(paper_id, paper_code) {
    const data = { paper_id, paper_code };
    return await apiCall("subject/paper/update", data);
  },

  async getSubjectPapers(subject_id) {
    const data = { subject_id };
    return await apiCall("subject/paper/list", data);
  },

  async getSubjectUnits(subject_id) {
    const data = { subject_id };
    return await apiCall("subject/unit/list", data);
  },

  async createSubjectUnit(subject_id, title, description) {
    const data = { subject_id, title, description };
    return await apiCall("subject/unit/add", data);
  },

  async updateSubjectUnit(unit_id, title, description) {
    const data = { unit_id, title, description };
    return await apiCall("subject/unit/update", data);
  },

  async deleteSubjectUnit(unit_id) {
    const data = { unit_id };
    return await apiCall("subject/unit/delete", data);
  },

  async getAllSubjectPapers() {
    const data = { source: "admin" };
    return await apiCall("subject/paper/list/all", data);
  },

  async setCurrentExam(class_id, exam_id) {
    const data = { class_id, exam_id };
    return await apiCall("period/class/set", data);
  },

  async countSubjects() {
    return await apiCall("subject/count", []);
  },

  async countClasses() {
    const data = { source: "admin" };
    return await apiCall("class/count", data);
  },

  async createUserRole(role_name) {
    const data = { role_name };
    return await apiCall("user/role/add", data);
  },

  async updateUserRole(data) {
    return await apiCall("user/role/update_role", data);
  },

  async getUserRoles() {
    const data = {};
    return await apiCall("user/role/list", data);
  },

  async countUsers() {
    const data = {};
    return await apiCall("user/count", data);
  },

  async getUsers() {
    const data = {};
    return await apiCall("user/list", data);
  },

  async createUser(data) {
    return await apiCall("user/create", data);
  },

  async countClassLevels() {
    const data = {};
    return await apiCall("class/level/count", data);
  },

  async countTerms() {
    const data = {};
    return await apiCall("term/count", data);
  },

  async countTests() {
    const data = {};
    return await apiCall("termly_exam/count", data);
  },

  async getSchoolInfo() {
    const data = {};
    return await apiCall("school/info", data);
  },

  async updateSchoolInfo(data) {
    return await apiCall("school/update", data);
  },

  async fetchAssessmentTypes() {
    const data = {};
    return await apiCall("assessment/type/list", data);
  },

  async fetchResidenceListing() {
    const data = {};
    return await apiCall("residence/list", data);
  },

  async updateSignature(data) {
    return await apiCall("school/signature/update", data);
  },

  async deleteStream(stream_id) {
    const data = { stream_id };
    return await apiCall("class/stream/delete", data);
  },

  async fetchReligions() {
    return await apiCall("list/religions", []);
  },
  async fetchHouses() {
    return await apiCall("list/houses", []);
  },
  async addHouse(houseName) {
    const data = { house: houseName };
    return await apiCall("add/house", data);
  },
  async updateHouse(houseId, houseName) {
    const data = { house: houseName, house_id: houseId };
    return await apiCall("school/house/update_house", data);
  },

  async fetchCountries() {
    return await apiCall("list/nations", []);
  },

  async uploadBadge(data) {
    return await apiCall("school/badge/upload", data);
  },
  async uploadSignature(data) {
    return await apiCall("school/signature/upload", data);
  },
  async inviteUser(data) {
    let response = await apiCall("user/user/invite_user", data);
    return response;
  },
  
  async deleteUser(data) {
    let response = await apiCall("user/user/remove_user", data);
    return response;
  },
  async fetchInterfaces() {
    const data = {};
    return await apiCall("system/externalinterface/list_interfaces", data);
  },

  async updateInterface(data) {
    return await apiCall("system/externalinterface/update_interface", data);
  },
  async fetchKeys() {
    return await apiCall("user/apikey/list_keys", []);
  },
   async createKey(data) {
    return await apiCall("user/apikey/new_key", data);
  },
};
